{
  "export": {
    "viewport": "Export viewport",
    "graph": "Export graph",
    "json": "Export JSON"
  },
  "action": {
    "recenter": "Recenter"
  }
}